interface AddDropPointInfoToGMapProps {
  city: string
  distance: number
  gmap: google.maps.Map
  handleSelection: (id: string) => void
  id: string
  locale: string
  name: string
  openingClassName: string
  openingHours: string[]
  postalCode: string
  streetName: string
  templateRef: HTMLDivElement
}
export const addDropPointInfoToGMap: (props: AddDropPointInfoToGMapProps) => HTMLDivElement = ({
  city,
  distance,
  gmap,
  handleSelection,
  id,
  locale,
  name,
  openingClassName,
  openingHours,
  postalCode,
  streetName,
  templateRef,
}) => {
  let infoBoxHtml = templateRef.innerHTML

  const distanceInKm = (distance / 1000).toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })

  infoBoxHtml = infoBoxHtml.replace('{{name}}', name || '')
  infoBoxHtml = infoBoxHtml.replace('{{streetName}}', streetName || '')
  infoBoxHtml = infoBoxHtml.replace('{{postalCode}}', postalCode || '')
  infoBoxHtml = infoBoxHtml.replace('{{city}}', city || '')
  infoBoxHtml = infoBoxHtml.replace('{{distance}}', distanceInKm)

  const infoBoxElement = document.createElement('div')
  infoBoxElement.innerHTML = infoBoxHtml

  const openingHoursElement = infoBoxElement.querySelector('.js-opening-list')
  if (openingHoursElement && openingHours?.length) {
    openingHours.forEach((item) => {
      const openingHour = document.createElement('div')
      openingHour.className = openingClassName
      openingHour.innerHTML = item
      openingHoursElement.appendChild(openingHour)
    })
  }

  const openingTrigger = infoBoxElement.querySelector('.js-opening-trigger')

  if (openingTrigger && openingHoursElement) {
    openingTrigger.addEventListener('click', () => {
      openingHoursElement.classList.toggle('hidden')
      openingTrigger.classList.toggle('active')
      if (openingTrigger.classList.contains('active')) {
        gmap.panBy(0, -100)
      }
    })
  }

  const droppointButton = infoBoxElement.querySelector('.js-select-button')
  if (droppointButton) {
    droppointButton.addEventListener('click', () => {
      handleSelection(id)
    })
  }

  return infoBoxElement
}
